"use client";

import React from "react";
import { motion, HTMLMotionProps } from "framer-motion";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface ButtonProps extends HTMLMotionProps<"button"> {
  variant?: "white" | "gradient";
  className?: string;
  children: React.ReactNode;
}

export default function Button({
  variant = "white",
  className,
  children,
  ...props
}: ButtonProps) {
  const variants = {
    white:
      "bg-white text-brand-black hover:bg-gray-100 shadow-lg shadow-white/10",
    gradient:
      "bg-gradient-to-r from-brand-red to-brand-dark-red text-white shadow-lg shadow-brand-red/20",
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={cn(
        "font-raleway flex cursor-pointer items-center justify-center rounded-full px-5 py-2.5 text-base font-bold transition-colors",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </motion.button>
  );
}
